// namespace (소문자)
export const NAMESPACE = 'chat';
//actions
export const FETCH_CHATROOMS = 'FETCH_CHATROOMS';
export const FETCH_CHATROOM = 'FETCH_CHATROOM';
export const FETCH_CHATROOM_WITH_STORE = 'FETCH_CHATROOM_WITH_STORE';
export const FETCH_CHATROOM_WITH_MEMBER = 'FETCH_CHATROOM_WITH_MEMBER';
export const FETCH_CHATMESSAGES_BY_SYSTEM_TYPE =
  'FETCH_CHATMESSAGES_BY_SYSTEM_TYPE';
export const FETCH_CHATMESSAGE_BY_SYSTEM_TYPE =
  'FETCH_CHATMESSAGE_BY_SYSTEM_TYPE';
export const FETCH_CHATMESSAGES = 'FETCH_CHATMESSAGES';
export const CREATE_CHATROOM = 'CREATE_CHATROOM';
export const SYNC_CHATROOM = 'SYNC_CHATROOM';
export const GET_CHATMESSAGES = 'GET_CHATMESSAGES';
export const GET_CHATMESSAGES2 = 'GET_CHATMESSAGES2';
export const RECEIVE_CHATMESSAGE = 'RECEIVE_CHATMESSAGE';
export const SEND_CHATMESSAGE_MANUAL = 'SEND_CHATMESSAGE_MANUAL';
export const UPLOAD_FILE = 'UPLOAD_FILE';
export const UPDATE_MEMBER_SCREEN_ACTIVED = 'UPDATE_MEMBER_SCREEN_ACTIVED';
export const UPDATE_MEMBER_SCREEN_ACTIVED_ALL =
  'UPDATE_MEMBER_SCREEN_ACTIVED_ALL';
export const EXCEL_DOWNLOAD_CHAT_MESSAGES_SYSTEM_TYPE =
  'EXCEL_DOWNLOAD_CHAT_MESSAGES_SYSTEM_TYPE';
export const SEND_ESTIMATE = 'SEND_ESTIMATE';
export const SEND_BOOKING = 'SEND_BOOKING';
export const SEND_INTERNETCOMMERCE = 'SEND_INTERNETCOMMERCE';
export const SEND_ESTIMATE_STORES = 'SEND_ESTIMATE_STORES';
export const FETCH_CHATROOM_WATCH = 'FETCH_CHATROOM_WATCH';
export const FETCH_CHATROOM_BLOCK = 'FETCH_CHATROOM_BLOCK';
export const FETCH_CHATROOM_CHATLISTTYPE = 'FETCH_CHATROOM_CHATLISTTYPE';
export const SEND_MOBILE_REQUEST = 'SEND_MOBILE_REQUEST';
export const RESET_CHAT_CACHE = 'RESET_CHAT_CACHE';
export const FETCH_CHATROOM_CHECK_LIMIT = 'FETCH_CHATROOM_CHECK_LIMIT';
export const REPORT_CHAT = 'REPORT_CHAT';
export const MESSAGE_NOTICE = 'MESSAGE_NOTICE';
export const FETCH_CHATMESSAGE_CHECKNEWREPLY =
  'FETCH_CHATMESSAGE_CHECKNEWREPLY';
export const FETCH_CHATROOMS_NEW_MESSAGES = 'FETCH_CHATROOMS_NEW_MESSAGES';
export const SEND_CHATMESSAGE_PROMOTION = 'SEND_CHATMESSAGE_PROMOTION';

//mutations
export const SET_CHATROOMS = 'SET_CHATROOMS';
export const SET_CHATROOMS_WITH = 'SET_CHATROOMS_WITH';
export const SET_CHATROOM = 'SET_CHATROOM';
export const SET_CHATMESSAGES_BY_MESSAGE_IDX =
  'SET_CHATMESSAGES_BY_MESSAGE_IDX';
export const SET_CHATMESSAGES = 'SET_CHATMESSAGES';
export const SET_CHATMESSAGES_LOCALSTORAGE = 'SET_CHATMESSAGES_LOCALSTORAGE';
export const SET_POST_PROCESSING = 'SET_POST_PROCESSING';
export const SET_CHATMESSAGES_SYSTEM_TYPE = 'SET_CHATMESSAGES_SYSTEM_TYPE';
export const SET_CHATMESSAGE_SYSTEM_TYPE = 'SET_CHATMESSAGE_SYSTEM_TYPE';
export const SET_CHATROOM_WATCH = 'SET_CHATROOM_WATCH';

//state
export const CHATROOMS_RESET_STATE = 'CHATROOMS_RESET_STATE';
export const CHATROOMS_WITH_RESET_STATE = 'CHATROOMS_WITH_RESET_STATE';
export const CHATROOM_RESET_STATE = 'CHATROOM_RESET_STATE';
export const CHATMESSAGES_RESET_STATE = 'CHATMESSAGES_RESET_STATE';
export const CHATMESSAGES_SYSTEM_TYPE_RESET_STATE =
  'CHATMESSAGES_SYSTEM_TYPE_RESET_STATE';
export const CHATMESSAGE_SYSTEM_TYPE_RESET_STATE =
  'CHATMESSAGE_SYSTEM_TYPE_RESET_STATE';
